class Footer {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {    
                config: ""
            }, 
            options
        );    

         
        this.footer = element; 
 
        this.footer.querySelector("#news-subscribe-footer").addEventListener("click", () => {
            this.footer.querySelector("#news-subscribe-footer").classList.add("loading");
            let email =  document.querySelector("#email-footer-news").value;
            this.checkKlaviyo(email); 
        });  

    }   

    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/checklist`, options);  
        const rep = await call.json();   
        if(JSON.parse(rep.rep.body).length > 0){
            this.footer.querySelector("#news-subscribe-footer").classList.remove("loading");
            this.footer.querySelector(".newslette-form .success").textContent = "Vous faites déjà parti de nos abonné(e)s !";
            this.footer.querySelector(".newslette-form .success").classList.add("ok");
            this.footer.querySelector(".newslette-form .content-field").classList.add("hide");
        }else{
            this.subKlaviyo(dataEmail); 
        } 
    }

    async subKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id, source: "footer"})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/subscribe`, options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("success");
            this.footer.querySelector("#news-subscribe-footer").classList.remove("loading");
            this.footer.querySelector(".newslette-form .success").classList.add("ok");
            this.footer.querySelector(".newslette-form .content-field").classList.add("hide");
        }  
    }

     
} 

if(app.klaviyo.state){
    const footer = new Footer(document.querySelector(".footer"));
}